// Şifre politikası — istemci tarafı kontrol listesi.
//
// Kaynak kural backend'dedir (Services/Concrete/PasswordPolicy.cs) ve her yazma yolunda yeniden
// denetlenir; burası yalnız kullanıcıya YAZARKEN hangi kuralın eksik olduğunu gösterir. Karakter
// sınıfları sunucuyla BİREBİR aynıdır — ayrışırsa form "tamam" der, sunucu reddeder:
//   harf  = Unicode L*  (.NET char.IsLetter)   — Türkçe ş/ğ/İ/ı harftir
//   rakam = Unicode Nd  (.NET char.IsDigit)
//   özel  = harf, rakam ve boşluk DIŞINDAKİ her karakter
// Uzunluk UTF-16 birimiyle ölçülür (.NET string.Length ile aynı).
// Mobil ikizi: mobile/src/utils/passwordPolicy.js (aynı test tablosu).

export const PASSWORD_MIN_LENGTH_FLOOR = 8;

// Yaklaşan süre dolumunun uyarı eşiği (gün) — üst bant ve profil kartı aynı değeri okur.
export const PASSWORD_EXPIRY_WARNING_DAYS = 14;

export const DEFAULT_PASSWORD_POLICY = Object.freeze({
  minLength: PASSWORD_MIN_LENGTH_FLOOR,
  requireAlphanumeric: false,
  requireSpecialCharacter: false,
  expiryMonths: 0,
});

const LETTER = /\p{L}/u;
const DIGIT = /\p{Nd}/u;
const SPACE = /\s/u;

export const isSpecialCharacter = (ch) => !LETTER.test(ch) && !DIGIT.test(ch) && !SPACE.test(ch);

// Sunucu yanıtı eksik/bozuk olsa bile taban 8'in altına inilmez.
export function normalizePasswordPolicy(policy) {
  const p = policy || {};
  const min = Number(p.minLength);
  return {
    minLength: Number.isFinite(min) ? Math.max(min, PASSWORD_MIN_LENGTH_FLOOR) : PASSWORD_MIN_LENGTH_FLOOR,
    requireAlphanumeric: p.requireAlphanumeric === true,
    requireSpecialCharacter: p.requireSpecialCharacter === true,
    expiryMonths: Number(p.expiryMonths) || 0,
  };
}

// Politikadaki ETKİN kurallar, sunucunun ihlal sırasıyla: uzunluk → harf+rakam → özel karakter.
export function evaluatePassword(password, policy) {
  const p = normalizePasswordPolicy(policy);
  const value = password || '';
  const rules = [{ key: 'minLength', ok: value.length >= p.minLength, params: { min: p.minLength } }];
  if (p.requireAlphanumeric) {
    rules.push({ key: 'alphanumeric', ok: LETTER.test(value) && DIGIT.test(value) });
  }
  if (p.requireSpecialCharacter) {
    rules.push({ key: 'specialCharacter', ok: [...value].some(isSpecialCharacter) });
  }
  return rules;
}

export const isPasswordAllowed = (password, policy) => evaluatePassword(password, policy).every((r) => r.ok);
